import React, { Component } from "react";


class LinksList extends Component {

  constructor() {
    super();
    this.state = {
      linksList: [],
    }
  }

  componentDidMount() {
    this.getLinksList();
  }

  async getLinksList() {
    const linksList = await (await fetch('http://web-portal.snappmobiledevelopment.co.nz/modules/links-list.php?API_KEY=e22e7629ff97ca3e5aaaa0dd2e6f1b88')).json();
    console.log(linksList);
    this.setState({linksList});
  }

  render() {
    const linksList = this.state.linksList.map(({id, name}) => {
      return <li key={id}>{name}</li>;
    });
    return (
      <div>
        <ul>
          {linksList}
        </ul>
      </div>
    );
  }

}

export default LinksList;


// WEBPACK FOOTER //
// ./src/components/LinksList.js